/**
 * Versioned Terms of Service acceptance — single source of truth for the
 * version string the frontend displays and submits.
 *
 * MUST mirror the backend constant `TOS_VERSION` in `backend/core/legal.py`.
 * The server gate rejects any submission that cites a different version, so
 * a drift between this value and the server constant produces a 422 on
 * every registration and checkout attempt.
 */

export const TOS_VERSION = '3.0';

/**
 * Cancellation summary shown when neither the listing nor its brand carries
 * its own policy.
 *
 * MUST mirror `TERMS_DEFAULT_CANCELLATION_SUMMARY` in `backend/core/legal.py`.
 */
export const TERMS_DEFAULT_CANCELLATION_SUMMARY =
  "Cancellations and refunds follow Belhop's Terms of Service.";

/** Deep link to the Cancellations and Refunds section of the Terms page. */
export const TERMS_CANCELLATIONS_HREF = '/terms#cancellations-and-refunds';

/**
 * Disclosure version recorded when a guest opts in to marketing e-mail.
 *
 * MUST mirror `MARKETING_EMAIL_CONSENT_VERSION` in `backend/core/legal.py`. The server rejects a
 * submission citing a different version. Changing the copy below means bumping the version in
 * both places.
 */
export const MARKETING_EMAIL_CONSENT_VERSION = '1.0';

/** The marketing e-mail disclosure the guest reads beside the checkbox. */
export const MARKETING_EMAIL_CONSENT_COPY =
  'Send me occasional emails about Belhop offers and new experiences. Unsubscribe any time.';
